export interface Tevent {
	id?: number;
	createDate: string;
	name: string;
	slug: string;
	content: string;
	content_plain: string;
	thumbnail: string;
	startDate: string;
	endDate: string;
	location: string;
	sales?: string;
	price: string;
	questionnaireSlug: string;
	active: boolean;
}

export const initialEvent: Tevent = {
	name: '',
	slug: '',
	content: '',
	content_plain: '',
	thumbnail: '',
	startDate: '',
	endDate: '',
	location: '',
	price: '',
	active: false,
	questionnaireSlug: '',
	createDate: '',
};
